import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as _ from 'underscore';
import { NotificationService } from '../../../../../../../app.common/modules/common/services/notification.service';
import { IngredientsService } from '../../../../../common/services/ingredients.service';
import { IIngredientSearchFilter } from '../../../../../model/ingredients/IIngredientSearchFilter';
import { IProductIngredient } from '../../../../../model/products/IProductIngredient';
import { IIngredientSelectItem } from '../../../../models/IIngredientSelectItem';

class ProductSelectIngredients implements ng.IController {

    public static $inject = [
        '$translate',
        'ingredientsService',
        'notificationService',
        '$localStorage'];

    public selectIngredientsForm: angular.IFormController;
    public resolve: {
        options: {
            selectedIngredients: IProductIngredient[];
        }};

    public selectedIngredients: Map<string, IProductIngredient> = new Map<string, IProductIngredient>();

    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    public model = {
        ingredients: [] as IIngredientSelectItem[],
        searchTerm: null as string,
        searchTermForEmptyScreen: null as string,
        waiting: false as boolean
    };

    public total: number = 0;
    public isSearch: boolean = false;

    constructor(
        private $translate: angular.translate.ITranslateService,
        private ingredientsService: IngredientsService,
        private notificationService: NotificationService,
    ) {
    }

    public $onInit(): void {
        this.resolve.options.selectedIngredients.forEach((ingredient) => {
            this.selectedIngredients.set(ingredient.ID, ingredient);
        });
        this.loadIngredients();
    }

    public selectIngredient(ingredient: IIngredientSelectItem, $event: Event) {
        $event.preventDefault();
        $event.stopPropagation();
        ingredient.IsSelected = !ingredient.IsSelected;
        this.selectIngredientsForm.$setDirty();

        if (this.selectedIngredients.has(ingredient.ID)) {
           this.selectedIngredients.delete(ingredient.ID);
        } else {
            this.selectedIngredients.set(ingredient.ID, ingredient as IProductIngredient);
        }
    }

    public search(text: string) {
        this.total = 0;
        this.model.ingredients = [];
        this.model.searchTerm = text;
        this.loadIngredients();
        this.isSearch = this.model.searchTerm !== null && this.model.searchTerm !== '' ;
    }

    public resetSearch() {
        this.model.searchTerm = '';
        this.search(this.model.searchTerm);
    }

    public loadIngredients() {
        if (this.model.waiting) {
            return;
        }

        if ( this.total && this.model.ingredients.length === this.total) {
            return;
        }

        this.model.waiting = true;

        const filter : IIngredientSearchFilter  = {
            searchTerm: this.model.searchTerm,
            limit: 20,
            searchAfterID: this.model.ingredients.length ? _.last(this.model.ingredients).ID : null,
            archived: false
        };

        this.model.searchTermForEmptyScreen = this.model.searchTerm;
        this.notificationService.showWaitingMessage();

        return this.ingredientsService.getIngredients(filter)
            .then((response) => {
                this.total = response.Total;
                const ingredients: IIngredientSelectItem[] = response.Items;
                ingredients.forEach((ingredient) => {
                    ingredient.IsSelected = !! this.selectedIngredients.has(ingredient.ID);
                });
                Array.prototype.push.apply(this.model.ingredients, ingredients);
            })
            .catch((e) => this.notificationService.showErrorMessage(e))
            .finally(() => {
                this.model.waiting = false;
                this.notificationService.clearAll();
            });
    }

    public confirm() {
        const selectionResult = {
            status: 'ok',
            selectedIngredients: [] as IProductIngredient[]
        };

        selectionResult.selectedIngredients = Array.from(this.selectedIngredients.values());
        this.modalInstance.close( { $value: selectionResult});
    }

    public dismiss() {
        this.modalInstance.close({$value: {status: 'close'}});
    }
}

angular.module('naut').component('productSelectIngredients', {
    template: require('./product-select-ingredients.component.html'),
    controller: ProductSelectIngredients,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-ingredients-list/product-select-ingredients/product-select-ingredients.component.ts